export enum ActivitiesType {
  unassigned = "unassigned",
  assignedToMe = "assignedToMe",
  mentioned = "mentioned",
  starred = "starred",
  closed = "closed",
  all = "all",
  awaitingReply = "awaitingReply",
}

export const ActivitiesLabels = {
  unassigned: "Unassigned",
  assignedToMe: "Assigned to me",
  mentioned: "Mentioned",
  starred: "Starred",
  closed: "Closed",
  all: "Open",
  awaitingReply: "Awaiting reply",
};
